export default "__VITE_ASSET__DmRfzi2O__"